import { GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE, CLEAR_EVENTS, GET_EVENT_SUCCESS, GET_EVENT_FAILURE } from '../types';

import initialState from '../initialState';

export default (state: any = initialState, action: any): any => {
  switch (action.type) {
    case CLEAR_EVENTS:
      return { ...state, events: [] };
    case GET_EVENTS_SUCCESS:
      return { ...state, events: action.events };
    case GET_EVENTS_FAILURE:
      return { ...state, error: action.error };
    case GET_EVENT_SUCCESS:
      return { ...state, events: [...state.events, action.event] };
    case GET_EVENT_FAILURE:
      return { ...state, error: action.error };
    default:
      return state;
  }
};
